/* file.icon.svg.js */

"use strict";
module.exports = {
    icon: `    
            <svg viewBox="0 0 24 24" preserveAspectRatio="none">
                <path class="foreground-gl" d="M13.2,8.4h6.6l-6.6-6.6V8.4 M4.8,0h9.6l7.2,7.2v14.4c0,1.3-1.1,2.4-2.4,2.4H4.8c-1.3,0-2.4-1.1-2.4-2.4V2.4
                    C2.4,1.1,3.5,0,4.8,0 M10.8,2.4h-6v19.2h6h8.4V10.8h-8.4V2.4z"/>
            </svg>

         `,
};
